import { useCallback } from 'react'

import { useCreateCompletionMutation } from '~generated/hooks'
import { CompletionType } from '~generated/types'

function useSummarize() {
  const [createCompletion, { loading }] = useCreateCompletionMutation()

  const summarize = useCallback(
    async (text: string) => {
      const { data: { createCompletion: res } = {} } = await createCompletion({
        variables: { input: { text, type: CompletionType.SUMMARIZE } },
      })
      return res
    },
    [createCompletion]
  )

  return {
    loading,
    summarize,
  }
}

export default useSummarize
